import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';

import { LibraryItemPage } from '../../pages/library';

export const Route = createFileRoute('/_shell/library/$itemId')({
  component: function LibraryItemRoute() {
    const { itemId } = Route.useParams();
    const navigate = useNavigate();

    return (
      <LibraryItemPage
        itemId={itemId}
        breadcrumb={<Link to="/library">Library</Link>}
        onDeleted={() => void navigate({ to: '/library' })}
      />
    );
  },
});
